export default __webpack_public_path__ + "static/media/vip-banner-cn.8d206433.webp";